import { Pipe, PipeTransform, inject } from '@angular/core';

import { CommonService } from '../services/common.service';

interface WorkerProfile {
  Id: number;
  ContactId: number;
  ProfileTypeId: number;
}

@Pipe({
  name: 'workerProfileRoute',
  standalone: false
})
export class WorkerProfileRoutePipe implements PipeTransform {
  private readonly commonService = inject(CommonService);

  transform(worker: WorkerProfile | null): string {
    if (!worker) {
      return '';
    }

    const profileTypeSuffix = this.commonService.getUserProfileTypeSufix(worker.ProfileTypeId);
    return `/next/contact/${worker.ContactId}/profile/${profileTypeSuffix}/${worker.Id}`;
  }
}
